import React from 'react';
import clsx from 'clsx';
import { TitleImage } from '../AboutPageGeneralComp';

/**
 * This component renders duplicate list item step. 
 * It is used as content in desing page example in body of
 * markdown in aboutPage page.
*/
const DuplicateListItem = ({elSubRefs}) => (
    <div id="Group8Sub7" ref ={elSubRefs[6]} className={clsx("subgroup")}>
        <h4 id="Group8Sub7">Duplicate a List Item</h4>
        <TitleImage 
            title='Select the "Layers" tab from the left menu. Here you can see the structure of your html file. You can navigate and select the "Table row 2" element. Your table is now selected and you can duplicate it by pressing the "Duplicate" icon from the block item inside the canvas.'
            srcImg= '/images/AboutPageMarkdownImg/13.jpg'
        />
        <TitleImage 
            title='You have now added more table rows in your "List Items" block.'
            srcImg= '/images/AboutPageMarkdownImg/14.jpg'
        />
    </div>
)

export default DuplicateListItem;
